/*
 * @Author: zhenhui.duan
 * @Date: 2024-01-10 09:31:46
 * @Description:
 */
import React from 'react';
import { Button } from '@ok/okd';

import { toLocale } from '@common/i18n';

import { PAGE_PATH } from '../../common/context';

import './index.less';

export default (props) => {
  const { currencyInfo, title } = props;
  const spots = currencyInfo?.products?.spot || [];

  const renderTradeLabel = (pairs) => {
    return pairs.map((p) => p.toUpperCase()).join('/');
  };

  const renderTradePath = (pairs) => {
    return `${PAGE_PATH.SPOT}/${pairs.map((p) => p.toLowerCase()).join('-')}`;
  };

  return (
    <div className="trade-box">
      <div className="trade-title">{title}</div>
      <div className="trade-content">
        {spots.map((s) => {
          const pairs = s.split('_');
          return (
            <div className="trade-item" key={s}>
              <div className="trade-label">{renderTradeLabel(pairs)}</div>
              <Button
                category={Button.CATEGORY.outline}
                type={Button.TYPE.primary}
                size={Button.SIZE.xs}
                href={renderTradePath(pairs)}
                onClick={() => {
                  window.seoMonitor.act(
                    'web_token_information_spot_trade_click'
                  );
                }}
              >
                {toLocale('currency_go_trade')}
              </Button>
            </div>
          );
        })}
      </div>
    </div>
  );
};
